import {store} from '../../../store/store'
import {api} from '../../../common/config'
import {ajaxUtil} from '../../../common/AjaxUtil'
import {directive as onClickaway} from 'vue-clickaway';
import {LocalStorageUtil, StorageUtil} from '../../../common/Auth'
import {CommonUtil} from '../../../common/CommonUtil'
export default {
  name: 'ebookreading',
  directives: {
    onClickaway: onClickaway,
  },
  data() {
    return {
      deleteNewsUrl: '',/*删除书签的url*/
      deleteNews: false,
      view: 0, /*用作计算本书阅读次数，刷新就重计为0,超过及到达20页算一次阅读次数*/
      viewTimes: 0,/*用作阅读限制用，登录以及公共阅读器不计算次数，个人未登录计算次数*/
      isSave: false, //当前页是否保存了书签
      bookmark: [],
      loginTip: false,
      num: 0,
      scrollBarHeight: 0,
      scrollBarHeight_catalogue: 0,
      labels: [],
      rendition: null,
      nowPageUrl: '',/*当前页面的章节url*/
      nowPageCfi: '', /*当前页面的cfi*/
      menus: '',
      catalogues: [],
      catalogueName: '',
      percentage: '',
      labelScroll: null,
      showLabel: false,
      showCatalogue: false,
      platform: 0,
      user: null,
      history: '',
      file: '',
      id: '',
      libCode: ''
    }
  },
  beforeMount() {
    this.file = decodeURI(this.$route.query.url);
    this.id = this.$route.query.id || '';
    this.libCode = this.$route.query.libCode || ''
  },
  mounted() {
    document.body.classList.add('epubBody');
      var right = (document.body.clientWidth - 1000)/2+1000-720+'px';
      document.querySelector('.catalogueList').style.right = right+'px';
    var _this = this;
    var book = ePub(this.file);
    // var book = ePub("https://s3.amazonaws.com/epubjs/books/moby-dick/OPS/package.opf");
    this.book = book;
    var rendition = book.renderTo(document.body, {
      manager: "continuous",
      flow: "scrolled",
      width: "1000px",
    });
    this.rendition = rendition;
    rendition.themes.default(
      {
        ".epub-container": {
          "margin": "0 auto"
        },
        "body": {
          "color": "#333",
          "background": "#fefbf2",
        },
        "body P:nth-of-type(1)": {
          "padding": "2em 0"
        },
        ".epub-view": {
          "background": "rgba(255,255,255,1)",
        },
        "img": {
          "display": "block",
          "margin": "0 auto"
        },
        "h1": {
          "padding": "2em 0",
          "margin":"0!important",
          "text-align": "center"
        },
        "p": {
          "font-family": "微软雅黑",
          "font-size": "18px!important"
        },
        "p span": {
          "font-family": "微软雅黑!important",
          "font-size": "18px!important"
        },
        ".sgc-toc-level-1 a, .sgc-toc-level-2 a": {
          "color": "#333",
        },
        ".sgc-toc-level-2, .sgc-toc-level-1": {
          "line-height": '24px',
        }
      }
    );
    var displayed = rendition.display()

    rendition.on("rendered", (section) => {
      var re = /.+\//g;
      var menus = section.href.match(re);
      if (menus) {
        this.menus = menus.join()
      }
      this.catalogues.forEach((item,index)=>{
        if(section.href.indexOf(item.href)!=-1 || item.href.indexOf(section.href)!=-1) {
          this.catalogueName = item.label
        }
      })
    });
    rendition.on("relocated", (location) => {
      this.view++;
      if(this.view == 20) {
        var data = {
          ebookId: _this.id,
          libCode: _this.libCode,
          peruser: _this.user?_this.user.idCard : ''
        }
        ajaxUtil.ajaxJson(api.ebook.addEbookReadRecord,data,"POST",null,null,_this)
      }
    });

    // 获取目录
    book.loaded.navigation.then(function (toc) {
      _this.catalogues = toc.toc;
    });

  },
  beforeRouteLeave(to,from,next) {
    if(this.book) {
      this.book.destroy();
    }
    document.body.classList.remove('epubBody')
    next()
  },
  methods: {
    hide() {
      this.showLabel = false;
      this.showCatalogue =false;
    },
    goback() {
      this.$router.push({name: 'ebookinfo',query: {id:this.id}})
    },
    makeDelete() {
      var cfi = this.deleteNewsUrl;
      if(cfi == this.nowPageCfi) {
        this.isSave = false
      }
      this.cancleMsg();
      for(var i = 0; i < this.bookmark.length; i++) {
        if(cfi == this.bookmark[i].url) {
          this.bookmark.splice(i,1)
          LocalStorageUtil.storeObject('bookmark',this.bookmark)
          return false;
        }
      }
    },
    deleteBookMark(cfi) {
      this.deleteNews = true;
      this.deleteNewsUrl = cfi;
    },
    cancleMsg() {
      this.deleteNews = false;
      this.deleteNewsUrl = '';
    },
    saveLabel() {
      this.isSave = !this.isSave
      for(var i = 0; i < this.bookmark.length; i++) {
        if(this.nowPageCfi == this.bookmark[i].url) {
          this.bookmark.splice(i,1)
          LocalStorageUtil.storeObject(this.file,this.bookmark)
          return false;
        }
      }
      var label = {
        file: this.file,
        url: this.nowPageCfi,
        name: this.catalogueName,
        percentage: parseInt(Number(this.percentage).toFixed(2) * 100),
        date: new Date().pattern('yyyyMMdd HH:mm')
      }
      this.catalogues.forEach((item, index)=>{
        if(item.href == this.nowPageUrl) {
          label.name = item.label
        }
      })
      this.bookmark.push(label)
      LocalStorageUtil.storeObject(this.file,this.bookmark)
    },
    tochapter(index) {
      var url = this.catalogues[index].href
      this.showCatalogue = false;
      if(url.indexOf(this.menus)==0) {
        this.rendition.display(url);
      } else {
        this.rendition.display(this.menus + url);
      }
    },
    changeCatalogueStatus() {
      setTimeout(()=>{
        this.showLabel = false;
        this.showCatalogue = !this.showCatalogue;
        if(this.showCatalogue) {
          this.$nextTick(()=>{
            var labelItemHeight = this.catalogues.length * 49;
            var wrapper = document.getElementsByClassName('catalogueWrapper')[0];
            var wrapperHeight = wrapper.getBoundingClientRect().height;
            if(wrapperHeight/labelItemHeight > 1) {
              this.scrollBarHeight_catalogue = 0;
              return  false;
            }
            this.scrollBarHeight_catalogue = wrapperHeight / labelItemHeight * wrapperHeight + 'px';
            var drag = this.$refs.scrollBar_catalogue;
            var box = this.$refs.scroll_catalogue;
            var con = this.$refs.catalogues;
            var out = this.$refs.catalogueWrapper;
            this.addScroll(drag,box,con,out)
          })
        }
      })
    },
    changeLabelStatus() {
      setTimeout(()=>{
        this.showCatalogue = false;
        this.showLabel = !this.showLabel
      })
    },
    addScroll(drag,box,con,out) {
      drag.onmousedown = function (ev) {
        var e = ev || window.event;
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        };
        var d_bkt = e.clientY - drag.offsetTop;
        document.onmousemove = function (ev) {
          var e = ev || window.event;
          var top = e.clientY - d_bkt;
          if (top <= 0) {
            top = 0;
          };
          if (top >= box.clientHeight - drag.clientHeight) {
            top = box.clientHeight - drag.clientHeight;
          };
          var scale = top / (box.clientHeight - drag.clientHeight);
          var cony = scale * (con.clientHeight - out.clientHeight);
          drag.style.top = top + 'px';
          con.style.top = -cony + 'px';
        }
        document.onmouseup = function () {
          document.onmousemove = null;
        }
      }
      var str = window.navigator.userAgent.toLowerCase();
      if (str.indexOf('firefox') != -1) {//火狐浏览器
        out.addEventListener('DOMMouseScroll', function (e) {
          e.preventDefault();//阻止窗口默认的滚动事件
          if (e.detail < 0) {
            var t = con.offsetTop + 20;
            if (t >= 0) {
              t = 0;
            };
            if (t <= -(con.clientHeight - out.clientHeight)) {
              t = -(con.clientHeight - out.clientHeight);
            };
            var scale = t / (con.clientHeight - out.clientHeight);
            var top = scale * (box.clientHeight - drag.clientHeight);
            con.style.top = t + 'px';
            drag.style.top = -top + 'px';
          };
          if (e.detail > 0) {
            var t = con.offsetTop - 20;
            if (t >= 0) {
              t = 0;
            };
            if (t <= -(con.clientHeight - out.clientHeight)) {
              t = -(con.clientHeight - out.clientHeight);
            };
            var scale = t / (con.clientHeight - out.clientHeight);
            var top = scale * (box.clientHeight - drag.clientHeight);
            con.style.top = t + 'px';
            drag.style.top = -top + 'px';
          };
        }, false);
      } else {//非火狐浏览器
        out.onmousewheel = function (ev) {
          var e = ev || window.event;
          if (e.preventDefault) {
            e.preventDefault();
          } else {
            e.returnValue = false;
          };
          if (e.wheelDelta > 0) {
            var t = con.offsetTop + 20;
            if (t >= 0) {
              t = 0;
            };
            if (t <= -(con.clientHeight - out.clientHeight)) {
              t = -(con.clientHeight - out.clientHeight);
            };
            var scale = t / (con.clientHeight - out.clientHeight);
            var top = scale * (box.clientHeight - drag.clientHeight);
            con.style.top = t + 'px';
            drag.style.top = -top + 'px';
          };
          if (e.wheelDelta < 0) {
            var t = con.offsetTop - 20;
            if (t >= 0) {
              t = 0;
            };
            if (t <= -(con.clientHeight - out.clientHeight)) {
              t = -(con.clientHeight - out.clientHeight);
            };
            var scale = t / (con.clientHeight - out.clientHeight);
            var top = scale * (box.clientHeight - drag.clientHeight);
            con.style.top = t + 'px';
            drag.style.top = -top + 'px';
          };
        }
      }
    }
  }
}
